module.exports = new __parcel__URL__("waves.15dc2590.glb").toString();